import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Calendar, StickyNote, AlertCircle, Wallet } from 'lucide-react';

export default function BottomNav() {
  const navItems = [
    { path: '/dashboard', icon: Home, label: 'Inicio', testId: 'bottom-nav-home' },
    { path: '/dashboard/calendar', icon: Calendar, label: 'Calendario', testId: 'bottom-nav-calendar' },
    { path: '/dashboard/expenses', icon: Wallet, label: 'Gastos', testId: 'bottom-nav-expenses' },
    { path: '/dashboard/announcements', icon: StickyNote, label: 'Avisos', testId: 'bottom-nav-announcements' },
    { path: '/dashboard/emergency', icon: AlertCircle, label: 'SOS', testId: 'bottom-nav-emergency' },
  ];

  return (
    <nav className="flex justify-around items-center py-3">
      {navItems.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          data-testid={item.testId}
          end={item.path === '/dashboard'}
          className={({ isActive }) =>
            `flex flex-col items-center gap-1 px-3 py-2 rounded-xl transition-all ${
              isActive ? 'text-[#1E3A5F]' : 'text-slate-400'
            }`
          }
        >
          <item.icon className="w-6 h-6" strokeWidth={1.5} />
          <span className="text-[10px] font-medium">{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
